export enum GrassrootlyFonts {
  EXO2 = "Exo2",
  EXO2Italic = "Exo2Italic",
}

const GrassrootlyProjectFonts = {
  [GrassrootlyFonts.EXO2]: require("../../../assets/fonts/Exo2-VariableFont_wght.ttf"),
  [GrassrootlyFonts.EXO2Italic]: require("../../../assets/fonts/Exo2-Italic-VariableFont_wght.ttf"),
};

export const ProjectFonts = {
  ...GrassrootlyProjectFonts,
};
